import React, { useMemo } from 'react';
import { SxProps, Tooltip } from '@mui/material';
import { CaptionBox, CaptionTextField, ImageCaption } from './style';
import { Attachment } from '../AttachmentDisplay/type';
import { FileNameTypes } from '@/__generated__/graphql';

type AttachmentCaptionBoxProps = {
  isUploadDialog?: boolean;
  isEditing: boolean;
  collectionName: string;
  attachmentCaption: string;
  setAttachmentCaption: (caption: string) => void;
  handleAttachmentCaption: () => void;
  setIsEditing: (editing: boolean) => void;
  handleCaption: (e: React.MouseEvent) => void;
  selectedAttachment: Attachment;
  sx?: SxProps;
  location?: string;
};

export const AttachmentCaption = ({
  isUploadDialog,
  isEditing,
  collectionName,
  attachmentCaption,
  setAttachmentCaption,
  handleAttachmentCaption,
  setIsEditing,
  handleCaption,
  selectedAttachment,
  sx,
  location = '',
}: AttachmentCaptionBoxProps) => {
  const isCaptionDisabled = !selectedAttachment.fileName && !selectedAttachment.url;

  const attachmentName = useMemo(() => {
    const caption =
      attachmentCaption ||
      selectedAttachment.caption ||
      selectedAttachment.fileName ||
      selectedAttachment.name;

    return selectedAttachment.name === FileNameTypes.IsometricDrawing
      ? `${caption} (Isometric)`
      : caption;
  }, [attachmentCaption, selectedAttachment]);

  return (
    <CaptionBox onClick={handleCaption}>
      {!isUploadDialog && isEditing && collectionName !== 'paintRegion' && !isCaptionDisabled ? (
        <CaptionTextField
          className={`captionTextField ${location}-attachment-caption-edit`}
          sx={sx}
          value={attachmentCaption}
          size="small"
          onChange={(e) => setAttachmentCaption(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') handleAttachmentCaption();
          }}
          onBlur={() => setIsEditing(false)}
          autoFocus
          multiline
          variant="outlined"
          slotProps={{
            input: {
              inputProps: { maxLength: 50 },
            },
          }}
          error={attachmentCaption.length >= 50}
          helperText={
            attachmentCaption.length >= 50
              ? 'Maximum 50 characters reached'
              : `${attachmentCaption.length}/50`
          }
        />
      ) : (
        <Tooltip title={isCaptionDisabled ? 'Caption is disabled for viewpoints' : attachmentName}>
          <ImageCaption
            sx={{ marginBottom: '32px' }}
            noWrap
            onClick={() => {
              if (!isCaptionDisabled) setIsEditing(true);
            }}
            style={isCaptionDisabled ? { color: '#aaa', cursor: 'not-allowed' } : {}}
          >
            {attachmentName}
          </ImageCaption>
        </Tooltip>
      )}
    </CaptionBox>
  );
};
